import React, { useEffect, useMemo, useState } from "react";
import ListDimension from "./Matrice/ListDimension";
import { useAppDispatch } from "../../_App/Redux/hooks";
import { updateMatriceApi } from "../../_App/Redux/Slices/matrice/matriceSlice";
import { handleKeyPress } from "../../_App/Helpers/helpers";

export default function Matrice({
  societe,
  getValue,
  setValue,
  index,
  matriceselected,
  listcaracteristique,
  reception,
  t,
  codearticle,

  getarticlebycode,
  showTicket,
  modifier,
}: any) {
  const dispatch = useAppDispatch();
  const [list, setlist] = useState<any[]>([[], [], []]);
  const [dimension, setdimension] = useState<any[]>([]);
  const [checkedlist, setcheckedlist] = useState<any[]>([]);
  const [list_dimension, setlist_dimension] = useState([]);
  const [selected_dimension, setselected_dimension] = useState("");
  const [showModalDimension, setshowModalDimension] = useState(false);
  const [dimension_change, setdimension_change] = useState("");
  const [index_dimension, setindex_dimension] = useState(-1);
  const [index_caracteristique, setindex_caracteristique] = useState(-1);
  const [matrice, setMatrice] = useState<any>();
  const [imagelist, setimagelist] = useState<any[]>([]);
  const [addCaracteristique, setaddCaracteristique] = useState<Boolean>(false);
  const changedimension = (
    dimension: string,
    idcaracteristique: string,
    caracteristiqueIndex: any,
    index: number,
    add_caracteristique: any
  ) => {
    setaddCaracteristique(add_caracteristique);
    setindex_caracteristique(caracteristiqueIndex);
    setindex_dimension(index);
    const foundcaratristique = listcaracteristique.find(
      (item: any) => item._id === idcaracteristique
    );
    if (foundcaratristique) {
      setdimension_change(dimension);
      setlist_dimension(foundcaratristique.valeurs);
      setselected_dimension(foundcaratristique);
      setshowModalDimension(true);
    }
  };

  useEffect(() => {
    if (matriceselected) {
      setMatrice(matriceselected);
    }
  }, [matriceselected]);
  const updateMatrice = async (valeur: string) => {
    // ajout itemm to list_dimension

    if (addCaracteristique) {
      const newmatrice = { ...matrice };
      if (index_dimension === 0) {
        newmatrice.list_dimension1 = [...newmatrice.list_dimension1, valeur];
      } else if (index_dimension === 1) {
        newmatrice.list_dimension2 = [...newmatrice.list_dimension2, valeur];
      } else if (index_dimension === 2) {
        newmatrice.list_dimension3 = [...newmatrice.list_dimension3, valeur];
      }
      setValue(`${index}.mtriceobj`, newmatrice);

      //  const response = await dispatch(updateMatriceApi(newmatrice));
      setMatrice(newmatrice);

      setaddCaracteristique(false);
      setshowModalDimension(false);
    } else {
      let newmatrice;
      if (index_dimension === 0) {
        const newList1 = [...matrice.list_dimension1];
        newList1[index_caracteristique] = valeur;

        newmatrice = {
          ...matrice,
          list_dimension1: newList1,
          list_dimension2: [...matrice.list_dimension2],
          list_dimension3: [...matrice.list_dimension3],
        };
      } else if (index_dimension === 1) {
        const newList2 = [...matrice.list_dimension2];
        newList2[index_caracteristique] = valeur;

        newmatrice = {
          ...matrice,
          list_dimension1: [...matrice.list_dimension1],
          list_dimension2: newList2,
          list_dimension3: [...matrice.list_dimension3],
        };
      } else if (index_dimension === 2) {
        const newList3 = [...matrice.list_dimension3];
        newList3[index_caracteristique] = valeur;

        newmatrice = {
          ...matrice,
          list_dimension1: [...matrice.list_dimension1],
          list_dimension2: [...matrice.list_dimension2],
          list_dimension3: newList3,
        };
      }
      setValue(`${index}.mtriceobj`, newmatrice);

      // Mettre à jour ligne_reception : remplacer l'ancienne valeur de la dimension par la nouvelle
      const oldValue = dimension_change;
      const toStr = (v: any) =>
        typeof v !== "string" && v !== null ? JSON.stringify(v) : String(v);
      const existingLignes: any[] = getValue(`${index}.ligne_reception`) || [];
      const updatedLignes = existingLignes.map((ligneItem: any) => {
        const updatedCara = (ligneItem.cara || []).map(
          (caraItem: any, caraIdx: number) => {
            if (caraIdx === index_dimension && toStr(caraItem.value) === toStr(oldValue)) {
              return { ...caraItem, value: valeur };
            }
            return caraItem;
          }
        );
        return { ...ligneItem, cara: updatedCara };
      });
      setValue(`${index}.ligne_reception`, updatedLignes);

      //const response = await dispatch(updateMatriceApi(newmatrice));
      setMatrice(newmatrice);

      setshowModalDimension(false);
    }
  };

  const removeLigneMatrice = async (valeur: string) => {
    // ajout itemm to list_dimension
    const newmatrice = { ...matrice };

    if (index_dimension === 0) {
      newmatrice.list_dimension1 = newmatrice.list_dimension1.filtrer(
        (item: string) => item !== valeur
      );
    } else if (index_dimension === 1) {
      newmatrice.list_dimension2 = newmatrice.list_dimension2.filter(
        (item: string) => item !== valeur
      );
    } else if (index_dimension === 2) {
      newmatrice.list_dimension3 = newmatrice.list_dimension3.filtrer(
        (item: string) => item !== valeur
      );
    }
    setValue(`${index}.mtriceobj`, newmatrice);

    setMatrice(newmatrice);
  };
  const insert_quantite = (
    item0: any,
    item1: any,
    item2: any,
    quantite: number
  ) => {
    let caracteristique_list: any[];
    if (item1 === "null") {
      caracteristique_list = [
        { caracteristique_id: dimension[0], value: item0 },
        { caracteristique_id: dimension[1], value: item1 },
        { caracteristique_id: dimension[2], value: item2 },
      ];
    } else {
      caracteristique_list = [
        { caracteristique_id: dimension[0], value: item0 },
        { caracteristique_id: dimension[1], value: item1 },
      ];
    }

    const data = { cara: caracteristique_list, quantite: quantite };

    let quantite_input = getValue(`${index}.quantite_input`) || 0;
    if (
      getValue(`${index}.ligne_reception`) &&
      getValue(`${index}.ligne_reception`)?.length !== 0
    ) {
      let isFound = false;
      const updatedMatrice = getValue(`${index}.ligne_reception`)
        ?.map((element: any) => {
          if (caracteristiqueEqual(element.cara, data.cara)) {
            isFound = true;

            if (quantite === 0) {
              // Return null to remove the element
              quantite_input = quantite_input - element.quantite;

              return { ...element, quantite: 0 };
            } else {
              quantite_input = quantite_input - element.quantite + quantite;

              return { ...element, quantite: quantite };
            }
          }
          return element;
        })
        .filter((element: any) => element !== null); // Filter out null elements

      if (!isFound) {
        // ajouter la quantite
        const copieinput_matrice = [
          ...getValue(`${index}.ligne_reception`),
          data,
        ];
        quantite_input = quantite_input + data.quantite;

        setValue(`${index}.ligne_reception`, copieinput_matrice);
      } else {
        setValue(`${index}.ligne_reception`, updatedMatrice);
      }
    } else {
      quantite_input = quantite_input + data.quantite;

      setValue(`${index}.ligne_reception`, [data]);
    }
    setValue(`${index}.quantite_input`, quantite_input);
  };

  const caracteristiqueEqual = (array1: any, array2: any) => {
    if (array1.length !== array2.length) {
      return false;
    }

    for (let i = 0; i < array1.length; i++) {
      const obj1 = array1[i];
      const obj2 = array2[i];
      if (compareValues(obj1, obj2)) {
        return false;
      }
    }

    return true;
  };
  function compareValues(obj1: any, obj2: any) {
    let value1 = obj1.value;
    let value2 = obj2.value;

    if (typeof value1 !== "string" && value1 !== null) {
      value1 = JSON.stringify(value1);
    }
    if (typeof value2 !== "string" && value2 !== null) {
      value2 = JSON.stringify(value2);
    }
    return value1.toString() !== value2.toString();
  }

  // Helper function for deep comparison of objects
  function deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true;

    if (
      typeof obj1 !== "object" ||
      obj1 === null ||
      typeof obj2 !== "object" ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  useEffect(() => {
    setcheckedlist([]);
    setlist([[], [], []]);
    if (matrice?._id) {
      setlist((prev: any) => {
        const newListArray = [...prev];
        newListArray[0] = matrice?.list_dimension1;
        return newListArray;
      });
      setlist((prev: any) => {
        const newListArray = [...prev];
        newListArray[1] = matrice?.list_dimension2;
        return newListArray;
      });
      setlist((prev: any) => {
        const newListArray = [...prev];
        newListArray[2] = matrice?.list_dimension3;
        return newListArray;
      });
      setdimension([
        matrice?.dimension1,
        matrice?.dimension2,
        matrice?.dimension3,
      ]);

      setcheckedlist(matrice.checked);
    }
  }, [matrice, showModalDimension]);
  const findimage = (dimmenssionid: string, valeur: string) => {
    const fils = getValue(`${index}.listfils`);
    const findarticle = fils?.find((item: any) =>
      item.caracteristiques.length !== 0
        ? item.caracteristiques[0]?.caracteristique_id === dimmenssionid &&
          item.caracteristiques[0]?.value === valeur
        : false
    );
    if (findarticle && findarticle.image?.length !== 0) {
      return findarticle.image[0];
    } else {
      return "notfound";
    }
  };
  const removeCarac = (indexCara: number, indexItem: number) => {
    // Valeur supprimée (pour nettoyer ligne_reception)
    const removedValue = list[indexCara][indexItem];
    const toStr = (v: any) =>
      typeof v !== "string" && v !== null ? JSON.stringify(v) : String(v);

    // Supprimer dans list (affichage)
    setlist((prev) => {
      const newList = [...prev];
      const subList = [...newList[indexCara]];
      subList.splice(indexItem, 1);
      newList[indexCara] = subList;
      return newList;
    });

    //  Supprimer dans matrice (state principal)
    if (
      matrice &&
      typeof matrice === "object" &&
      matrice !== null &&
      !Array.isArray(matrice)
    ) {
      const newmatrice = { ...matrice };
      if (indexCara === 0) {
        newmatrice.list_dimension1 = newmatrice.list_dimension1.filter(
          (_: any, i: any) => i !== indexItem
        );
      } else if (indexCara === 1) {
        newmatrice.list_dimension2 = newmatrice.list_dimension2.filter(
          (_: any, i: any) => i !== indexItem
        );
      } else if (indexCara === 2) {
        newmatrice.list_dimension3 = newmatrice.list_dimension3.filter(
          (_: any, i: any) => i !== indexItem
        );
      }
      setValue(`${index}.mtriceobj`, newmatrice);
      setMatrice(newmatrice);
    }

    // Supprimer de ligne_reception les entrées liées à cette valeur et recalculer quantite_input
    const existingLignes: any[] = getValue(`${index}.ligne_reception`) || [];
    let removedQty = 0;
    const filteredLignes = existingLignes.filter((ligneItem: any) => {
      const caraItem = (ligneItem.cara || [])[indexCara];
      if (caraItem && toStr(caraItem.value) === toStr(removedValue)) {
        removedQty += Number(ligneItem.quantite) || 0;
        return false;
      }
      return true;
    });
    setValue(`${index}.ligne_reception`, filteredLignes);
    const currentQtyInput = Number(getValue(`${index}.quantite_input`)) || 0;
    setValue(`${index}.quantite_input`, currentQtyInput - removedQty);
  };

  return (
    <div>
      {matriceselected !== null ? (
        <>
          <div className=" table-responsive mt-5  ">
            <table id="style-2" className=" style-2 text-center bg-white ">
              <thead style={{ background: "#f1f2f3" }}>
                <tr>
                  <th className="text-center"></th>

                  {list[1]?.map((item1: any, poidsIndex: number) => (
                    <th
                      className="text-center"
                      style={{
                        cursor: modifier || !reception?.cloturer ? "pointer" : "default",
                        width: "100px",
                        height: "40px",
                        padding: "0 0 0 0",
                        border: "1px solid #ccc",
                        backgroundColor: listcaracteristique.find(
                          (item: any) => item._id === dimension[1]
                        )?.color
                          ? item1.valeur
                          : null,
                      }}
                      key={poidsIndex}
                    >
                      <div
                        onClick={() =>
                          (modifier || !reception?.cloturer) &&
                          changedimension(
                            item1,
                            dimension[1],
                            poidsIndex,
                            1,
                            false
                          )
                        }
                      >
                        {" "}
                        {listcaracteristique.find(
                          (item: any) => item._id === dimension[1]
                        )?.color
                          ? item1.libelle
                          : item1}
                      </div>
                      {(modifier || !reception?.cloturer) && (
                        <div>
                          <span
                            className="c-primary float-left"
                            onClick={() => removeCarac(1, poidsIndex)}
                          >
                            <i className="fas fa-minus-circle"></i>{" "}
                          </span>
                        </div>
                      )}
                      {poidsIndex === list[1].length - 1 && (modifier || !reception?.cloturer) && (
                        <div>
                          <span
                            className="c-primary float-right"
                            onClick={() =>
                              changedimension(
                                item1,
                                dimension[1],
                                poidsIndex,
                                1,
                                true
                              )
                            }
                          >
                            <i className="fas fa-plus-circle fa-lg"></i>
                          </span>
                        </div>
                      )}
                      {list[2]?.map((item2: any, indexlist2: any) => (
                        <>
                          <th className="border text-center">
                            <div
                              style={{
                                cursor: modifier || !reception?.cloturer ? "pointer" : "default",
                                width: "100px",
                                height: "40px",
                                backgroundColor: listcaracteristique.find(
                                  (item: any) => item._id === dimension[2]
                                )?.color
                                  ? item2.valeur
                                  : null,
                              }}
                              onClick={() =>
                                (modifier || !reception?.cloturer) &&
                                changedimension(
                                  item2,
                                  dimension[2],
                                  indexlist2,
                                  2,
                                  false
                                )
                              }
                            >
                              {listcaracteristique.find(
                                (item: any) => item._id === dimension[2]
                              )?.color
                                ? item2.libelle
                                : item2}
                            </div>
                            {(modifier || !reception?.cloturer) && (
                              <div>
                                <span
                                  className="c-primary float-left"
                                  onClick={() => removeCarac(2, indexlist2)}
                                >
                                  <i className="fas fa-minus-circle"></i>{" "}
                                </span>
                              </div>
                            )}
                            {indexlist2 === list[2].length - 1 && (modifier || !reception?.cloturer) && (
                              <div>
                                <span
                                  className="c-primary float-right"
                                  onClick={() =>
                                    changedimension(
                                      item2,
                                      dimension[2],
                                      indexlist2,
                                      2,
                                      true
                                    )
                                  }
                                >
                                  <i className="fas fa-plus-circle fa-lg"></i>
                                </span>
                              </div>
                            )}
                          </th>
                        </>
                      ))}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {list[0]?.map((item0: any, item0Index: number) => (
                  <tr key={item0Index}>
                    <td className="text-center">
                      <div
                        style={{
                          cursor: modifier || !reception?.cloturer ? "pointer" : "default",
                          width: "100px",
                          height: "40px",
                          padding: "0 0 0 0",
                          border: "1px solid #ccc",
                          backgroundColor: listcaracteristique.find(
                            (item: any) => item._id === dimension[0]
                          )?.color
                            ? item0.valeur
                            : null,
                        }}
                        onClick={() =>
                          (modifier || !reception?.cloturer) &&
                          changedimension(
                            item0,
                            dimension[0],
                            item0Index,
                            0,
                            false
                          )
                        }
                      >
                        {listcaracteristique.find(
                          (item: any) => item._id === dimension[0]
                        )?.color
                          ? item0.libelle
                          : item0}
                      </div>
                      {(modifier || !reception?.cloturer) && (
                        <div>
                          <span
                            className="c-primary float-left"
                            onClick={() => removeCarac(0, item0Index)}
                          >
                            <i className="fas fa-minus-circle"></i>{" "}
                          </span>
                        </div>
                      )}
                      {item0Index === list[0].length - 1 && (modifier || !reception?.cloturer) && (
                        <div>
                          <span
                            className="c-primary float-right"
                            onClick={() =>
                              changedimension(
                                item0,
                                dimension[0],
                                item0Index,
                                0,
                                true
                              )
                            }
                          >
                            <i className="fas fa-plus-circle fa-lg"></i>
                          </span>
                        </div>
                      )}
                    </td>

                    {list[1]?.map((item1: any, item1Index: number) => (
                      <td
                        key={item1Index}
                        style={{
                          cursor: "pointer",
                          width: "50px",
                        }}
                      >
                        {list[2]?.length !== 0 ? (
                          list[2]?.map((item2: any, item2Index: number) => (
                            <td
                              key={item2Index}
                              className="border"
                              style={{
                                height: "50px",
                                width: "100px",
                              }}
                            >
                              <div className="checkbox-container">
                                <input
                                  type="number"
                                  style={{
                                    height: "50px",
                                    width: "100%",
                                  }}
                                  disabled={
                                    !modifier &&
                                    !modifier &&
                                    reception?.cloturer
                                  }
                                  value={
                                    getValue(`${index}.ligne_reception`).find(
                                      (item: any) =>
                                        caracteristiqueEqual(item.cara, [
                                          {
                                            caracteristique_id: dimension[0],
                                            item0,
                                          },
                                          {
                                            caracteristique_id: dimension[1],
                                            item1,
                                          },
                                          {
                                            caracteristique_id: dimension[2],
                                            item2,
                                          },
                                        ])
                                    )?.quantite
                                  }
                                  onKeyPress={handleKeyPress}
                                  onChange={(e) =>
                                    insert_quantite(
                                      item0,
                                      item1,
                                      item2,
                                      parseFloat(e.target.value) || 0
                                    )
                                  }
                                  className="text-center numberinput"
                                />

                                <div className="checkbox-label"></div>
                              </div>
                            </td>
                          ))
                        ) : (
                          <td
                            className="border"
                            style={{
                              cursor: "pointer",
                              width: "100px",
                            }}
                          >
                            <div className="checkbox-container">
                              <input
                                type="number "
                                style={{
                                  height: "50px",
                                  width: "100%",
                                  color: "blue",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  textAlign: "center",
                                  lineHeight: "50px",
                                }}
                                value={
                                  getValue(`${index}.ligne_reception`)?.find(
                                    (item: any) =>
                                      caracteristiqueEqual(item.cara, [
                                        {
                                          caracteristique_id: dimension[0],
                                          value: item0,
                                        },
                                        {
                                          caracteristique_id: dimension[1],
                                          value: item1,
                                        },
                                      ])
                                  )?.quantite
                                }
                                onKeyPress={handleKeyPress}
                                onClick={() => {
                                  if (
                                    !modifier &&
                                    !modifier &&
                                    reception?.cloturer
                                  ) {
                                    showTicket(
                                      item0.libelle ? item0.libelle : item0,
                                      item1.libelle ? item1.libelle : item1
                                    );
                                  }
                                }}
                                onChange={(e) =>
                                  insert_quantite(
                                    item0,
                                    item1,
                                    "null",
                                    parseFloat(e.target.value) || 0
                                  )
                                }
                                className={
                                  !modifier && reception?.cloturer
                                    ? "custom-disabled"
                                    : "text-center numberinput "
                                }
                              />

                              <div className="checkbox-label"></div>
                            </div>
                          </td>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ListDimension
            dimension_change={dimension_change}
            listdimension={list_dimension}
            selecteddimension={selected_dimension}
            ShowModal={showModalDimension}
            setShowModal={setshowModalDimension}
            updateMatrice={updateMatrice}
            removeLigneMatrice={removeLigneMatrice}
            t={t}
          />
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
}
